export default __webpack_public_path__ + "static/media/mountain-4.f1425d34.png";